import { useState, useEffect } from 'react';
import Header from './Header';
import Collation from './Collation';
import Inspection from './Inspection';
import Login from './Login'
import StorageSearch from './StorageSearch';
import StorageRegister from './StorageRegister';
import Test from './Test';
import { Container } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DifferenceIcon from '@mui/icons-material/Difference';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import GetAppIcon from '@mui/icons-material/GetApp';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import SearchIcon from '@mui/icons-material/Search';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import { MenuButton } from '../molecules/MenuButton';
import { BottomButton } from '../molecules/BottomButton';
import { UserName } from '../molecules/UserName';
import CustomDialog from '../molecules/CustomDialog';
import { Copyright } from '../organisms/Copyright';
import { LastTest } from '../organisms/LastTest';
import { Version } from '../organisms/Version';

function TopMenu(){
    const [ menu, setMenu ] = useState(0);
    const [ loggedIn, setLoggedIn ] = useState(false);
    const [ userName, setUserName ] = useState("");
    const [ open, setOpen ] = useState(false);
    const [ needTest, setNeedTest ] = useState(false);

    const token = localStorage.getItem("authToken");
    useEffect(() => {
        if(token !== null){
            setLoggedIn(true);
        } else {
            Logout();
        }
    }, [token]);

    const userNameStored = localStorage.getItem("userName");
    useEffect(() => {
        if(userNameStored !== null){
            setUserName(userNameStored);
        } else {
            Logout();
        }
    }, [userNameStored]);

    const employeeId = localStorage.getItem("employeeId");
    useEffect(() => {
        if(!employeeId){
            Logout();
        }
    }, [employeeId]);

    function Logout() {
        setLoggedIn(false);
        setUserName("");
        localStorage.removeItem("authToken");
        localStorage.removeItem("userName");
        localStorage.removeItem("employeeId");
    }

    return (
        <>
        <Header />
        { menu === 0 && !loggedIn &&
        <>
        <Container component = "main" maxWidth = "xs" sx ={{marginTop: 2}}>
            <LastTest needTest={needTest} setNeedTest={setNeedTest}/>
            <MenuButton icon = {<SearchIcon />} onClick = {() => setMenu(6)}>置場確認</MenuButton>
        </Container>
        <BottomButton icon = {<LoginIcon />}onClick = {() => setMenu(10)}>ログイン</BottomButton>
        </>
        }

        { menu === 0 &&
        loggedIn &&
        <>
        <Container component = "main" maxWidth = "xs">
            <UserName>{userName}</UserName>
            <LastTest needTest={needTest} setNeedTest={setNeedTest}/>
            {!needTest &&
            <>
            <MenuButton icon = {<ContentCopyIcon />} onClick = {() => setMenu(1)}>照合(大同現品票⇔東北命令書)</MenuButton>
            <MenuButton icon = {<DifferenceIcon />} onClick = {() => setMenu(2)}>照合(大同現品票⇔東北現品票)</MenuButton>
            <MenuButton icon = {<CompareArrowsIcon />} onClick = {() => setMenu(3)}>照合(東北命令書⇔東北現品票)</MenuButton>
            <MenuButton icon = {<GetAppIcon />} onClick = {() => setMenu(4)}>素材検品</MenuButton>
            <MenuButton icon = {<WarehouseIcon />} onClick = {() => setMenu(5)}>置場管理</MenuButton>
            </>
            }
            <MenuButton icon = {<SearchIcon />} onClick = {() => setMenu(6)}>置場確認</MenuButton>
            <MenuButton icon = {<AssignmentTurnedInIcon />} onClick = {() => setMenu(7)}>点検</MenuButton>
        </Container>
        {/* <BottomButton icon = {<LogoutIcon />}onClick = {() => setOpen(true)}>ログアウト</BottomButton> */}
        <BottomButton icon = {<LogoutIcon />}onClick = {() => Logout()}>ログアウト</BottomButton>
        </>
        }
        <CustomDialog
            title = "ログアウトしました"
            buttonText = "閉じる"
            // flagOnClose
            onClick = {() => {
                Logout();
                setOpen(false);
            }}
            open = {open}
        />
        {/* ログイン */}
        { menu === 10 &&
        <div>
            <Login menu = {menu} loggedIn = {loggedIn} userName = {userName}
            setMenu = {setMenu} setLoggedIn = {setLoggedIn} setUserName = {setUserName}/>
        </div>
        }
        {/* 照合 */}
        { (menu === 1 || menu === 2 || menu === 3) &&
        <div>
            <Collation menu = {menu} userName = {userName} setMenu = {setMenu}/>
        </div>
        }
        {/* 素材検品 */}
        { menu === 4 &&
        <div>
            <Inspection menu = {menu} userName = {userName} setMenu = {setMenu}/>
        </div>
        }
        {/* 置場管理 */}
        { menu === 5 &&
        <div>
            <StorageRegister menu = {menu} userName = {userName} setMenu = {setMenu}/>
        </div>
        }
        {/* 置場確認 */}
        { menu === 6 &&
        <div>
            <StorageSearch menu = {menu} userName = {userName} setMenu = {setMenu}/>
        </div>
        }
        {/* 点検 */}
        { menu === 7 &&
        <div>
            <Test menu = {menu} userName = {userName} setMenu = {setMenu}/>
        </div>
        }
        <Version sx={{ mt: 1, mb:1}} />
        <Copyright sx={{ mt: 1, mb:2}} />
        </>
    );
}

export default TopMenu;